import "core-js/modules/es.array.concat.js";
import React from 'react';
import { styled, useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import CenterContent from 'components/CenterContent';
import Spinner from 'components/Spinner';
import Button from 'components/Button';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import TooltipButton from 'components/TooltipButton';
import Flex, { Box } from 'components/Flex';
import Text from 'components/Text';
import { ResizeHandleVertical } from 'components/ResizeHandle';
import { INSET_PX, NAV_HEIGHT, PANEL_HEADER_HEIGHT } from './constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Reserves layout space in ContentRow so MainContent is pushed left on desktop.
// Separate from the visual panel so their visibility can be controlled independently.
var SidebarPlaceholder = styled.div.withConfig({
  displayName: "SidebarDock__SidebarPlaceholder",
  componentId: "sc-1cu4ajm-0"
})(["flex-shrink:0;"]);
var SidebarAgentContainer = styled.div.withConfig({
  displayName: "SidebarDock__SidebarAgentContainer",
  componentId: "sc-1cu4ajm-1"
})(["flex:1;min-height:0;overflow:hidden;position:relative;"]);
export function SidebarDock(_ref) {
  var containerId = _ref.containerId,
    isDesktop = _ref.isDesktop,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    isHiddenByPage = _ref.isHiddenByPage,
    hasInitialized = _ref.hasInitialized,
    loadingStatus = _ref.loadingStatus,
    coachAiName = _ref.coachAiName,
    modals = _ref.modals,
    _ref$geometry = _ref.geometry,
    sidebarWidth = _ref$geometry.sidebarWidth,
    startSidebarWidthDrag = _ref$geometry.startSidebarWidthDrag;
  var theme = useTheme();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var shouldHide = isHiddenByPage;
  // Keep panel in DOM after first init to preserve the mounted agent
  var isPanelInDom = isDesktop || isOpen || hasInitialized;
  var isPanelVisible = !shouldHide && (isDesktop || isOpen);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [modals, /*#__PURE__*/_jsx(SidebarPlaceholder, {
      "aria-hidden": "true",
      style: !isDesktop || shouldHide ? {
        display: 'none'
      } : {
        width: sidebarWidth
      }
    }), isPanelInDom && /*#__PURE__*/_jsxs(Box, {
      breakpoints: "m",
      position: "fixed",
      overflow: "hidden",
      display: isPanelVisible ? 'flex' : 'none',
      z: ['modals', 'raised'],
      flexDirection: "column",
      right: 0,
      top: [0, NAV_HEIGHT],
      left: [0, 'unset'],
      bottom: [0, 'unset'],
      style: isDesktop ? {
        width: sidebarWidth
      } : undefined,
      height: [undefined, "calc(100vh - ".concat(NAV_HEIGHT, " - (").concat(theme.globals.spacing.s, " * 2))")],
      m: "s",
      borderRadius: "large",
      border: ['none', 'thin'],
      backgroundColor: "background",
      boxShadow: ['raised', 'none'],
      children: [isDesktop && /*#__PURE__*/_jsx(ResizeHandleVertical, {
        left: 0,
        onPointerDown: startSidebarWidthDrag
      }), !isDesktop && /*#__PURE__*/_jsxs(Flex, {
        gap: "xs",
        px: "s",
        height: PANEL_HEADER_HEIGHT,
        shrink: 0,
        borderBottom: "thin",
        children: [/*#__PURE__*/_jsx(CoachAiAvatar, {}), /*#__PURE__*/_jsx(Box, {
          grow: 1,
          children: /*#__PURE__*/_jsx(Text, {
            fontWeight: "bold",
            children: coachAiName
          })
        }), /*#__PURE__*/_jsx(Button, {
          iconOnly: true,
          icon: "x",
          variant: "transparent",
          onClick: function onClick() {
            return setIsOpen(false);
          },
          children: t('actions_close')
        })]
      }), /*#__PURE__*/_jsx(SidebarAgentContainer, {
        id: containerId,
        children: loadingStatus === 'loading' && /*#__PURE__*/_jsx(CenterContent, {
          fillParent: true,
          children: /*#__PURE__*/_jsx(Spinner, {})
        })
      })]
    }), !isDesktop && !isOpen && !shouldHide && /*#__PURE__*/_jsx(TooltipButton, {
      round: true,
      iconOnly: true,
      variant: "transparent",
      icon: /*#__PURE__*/_jsx(Box, {
        mr: "-xs",
        ml: "-xs",
        children: /*#__PURE__*/_jsx(CoachAiAvatar, {
          scale: 1.5
        })
      }),
      position: "fixed",
      z: "alerts",
      tooltipPlacement: "top-end",
      onClick: function onClick() {
        return setIsOpen(true);
      },
      style: {
        right: INSET_PX,
        bottom: INSET_PX
      },
      children: t('coach_ai_ask', {
        coachAiName: coachAiName
      })
    })]
  });
}